import React, {useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import Api from "./services/Api";
import WebConstant from "./WebConstant";
import {getCookie} from "./utility/WebAnalytic";

const ExchangeToken = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    console.log("searchParams", searchParams);
    //const [authResponse, setAuthResponse] = React.useState(null);
    //const [destinationPage, setDestinationPage] = React.useState(null);

    useEffect(() => {
        const exchangeAuthCodeForToken = async () => {
            // Extract error and code from URL query parameters (similar to request.getParameter)
            console.log("exchange token");
            const error = searchParams.get("error");
            const authCode = searchParams.get("code");
            const nonce = sessionStorage.getItem(WebConstant.NONCE);

            if (error) {
                console.error("Okta /authorize returns error:", error);
                Api.sendAuthError({error: error});
                navigate("/login/error");
                return;
            }

            let DURL = sessionStorage.getItem(WebConstant.DURL);
            let signOnPolicy = sessionStorage.getItem(WebConstant.SIGN_ON_POLICY);
            let fromAction = sessionStorage.getItem(WebConstant.FROM_ACTION);
            let isSkipEnroll = sessionStorage.getItem(WebConstant.SKIPENROLL) === "Y";
            let idp = sessionStorage.getItem(WebConstant.IDP);
            //convert null to undefined to avoid 400 error when calling mslogin
            if (idp == null)
                idp = undefined;
            const appIdFromSession = sessionStorage.getItem(WebConstant.SSO_APP_ID);
            let appIdFromUserInput = undefined;
            if (appIdFromSession && !isNaN(appIdFromSession) && Number(appIdFromSession) > 0) {
                appIdFromUserInput = Number(appIdFromSession);
            }

            let appId = appIdFromUserInput?appIdFromUserInput:WebConstant.defaultAppId;

            // Clear temporary storage
            sessionStorage.removeItem(WebConstant.SIGN_ON_POLICY);
            sessionStorage.removeItem(WebConstant.NONCE);
            sessionStorage.removeItem(WebConstant.FROM_ACTION);
            sessionStorage.removeItem(WebConstant.SKIPENROLL);
            sessionStorage.removeItem(WebConstant.IDP);

            try {
                // Simulate the Okta token exchange by calling a backend API
                let request = {
                    code: authCode,
                    signOnPolicy: signOnPolicy ? signOnPolicy : WebConstant.SignOnPolicyEnumValues.DEFAULT,
                    nonce: nonce,
                    appId: appId,
                    destinationUrl: DURL,
                    isSkipEnroll: isSkipEnroll,
                    idpFromUserInput: idp
                };
                if (!DURL) {
                    delete request.destinationUrl;
                }
                if (fromAction) {
                    request.fromAction = fromAction;
                }
                const str = JSON.stringify(request, null, 4); // (Optional) beautiful indented output.
                console.log(str);
                const authResponse = await Api.getSSOSession(request);

                if (!authResponse) {
                    navigate("/login/error");
                    return;
                }

                console.log("authResponse", authResponse);
                console.dir(authResponse);

                //Create cb_login cookie
                let domain = ".collegeboard.org";
                let cbLoginCookie = `${WebConstant.cbLoginCookieName}=${authResponse.unifiedSessionId}; Path=/; Secure; SameSite=Strict; domain=${domain}`;
                document.cookie = cbLoginCookie;
                let cbTreeEnvCookie = `${WebConstant.cbTreeEnvCookieName}=pine; Path=/; Secure; SameSite=Strict; domain=${domain}`;

                if (window.appConfig.envName !== "prod") {
                    cbTreeEnvCookie = `cb_tree_env=${window.appConfig.envName}; Path=/; Secure; SameSite=Strict; domain=${domain}`;
                    let lowerEnvCookie = `lower_Env=${window.appConfig.envName}; Path=/; Secure; SameSite=Strict; domain=${domain}`;
                    document.cookie = lowerEnvCookie;
                }
                document.cookie = cbTreeEnvCookie;

                // Drop Web Analytics cookie
                dropWebAnalyticsCookie(authResponse, appId);

                const mismatchType = authResponse.mismatchType;
                if (mismatchType && mismatchType !== "noMismatch") {
                    if (mismatchType === "idpMismatchEcl") {
                        console.error("IdP mismatch: expected EPL but got student");
                        navigate("/login/mismatchError", {state: {mismatchType: "idpMismatchEcl", destinationUrl: authResponse.destinationUrl}});
                        return;

                    } else if (mismatchType === "idpMismatchEpl") {
                        console.error("IdP mismatch: expected ECL but got professional");
                        navigate("/login/mismatchError", {state: {mismatchType: "idpMismatchEpl", destinationUrl: authResponse.destinationUrl}});
                        return;

                    }
                }

                //only for student, extra step and redirect to destination page
                //for prof, forward to destination page.
                let destination = authResponse.destinationUrl;
                if (authResponse.namespace === "st") {
                    destination = getRoutingDestination(destination);
                }
                console.log("destination", destination);

                //setDestinationPage(destination);

                //navigate(destination);
                sessionStorage.removeItem(WebConstant.DURL);
                sessionStorage.removeItem(WebConstant.SSO_APP_ID);
                window.location.href = destination;
            } catch (err) {
                console.error("Token exchange failed:", err);
                navigate("/login/error");
            }
        };

        exchangeAuthCodeForToken().catch(error => {
            console.error("Error during login process exchangeAuthCodeForToken", error);
            navigate("/login/error");
        });
    }, []);

    function dropWebAnalyticsCookie(authSessionInfo, appId) {
        // Extract namespace from authSessionInfo (assumed to be an object)
        const namespaceInLoginSession = authSessionInfo.namespace;
        let person = {
            accountId: authSessionInfo.accountId,
            oktaAccountId: authSessionInfo.oktaAccountId,
        };
        // Helper function to create cookie data (simulating WebAnaylyticsCookieManager.getCookie)
        const cookieValue = getCookie(
            person,
            namespaceInLoginSession.toLowerCase(),
            appId
        );
        document.cookie = `iamkiwilog=${cookieValue}; domain=.collegeboard.org; max-age=300; Secure; SameSite=Strict; Path=/`;
    }

    function useSedWidget() {
        return true;
    }

    function getDurlWithSedWidget(destinationpage) {
        let appId = sessionStorage.getItem(WebConstant.SSO_APP_ID)
            ? sessionStorage.getItem(WebConstant.SSO_APP_ID)
            : "466";
        let sedWidgetUrl = `https://connect-${window.appConfig.envName}.collegeboard.org?source=L`;
        if (window.appConfig.envName === "prod") {
            sedWidgetUrl = `https://connect.collegeboard.org?source=L`;
        }
        let sb = sedWidgetUrl;
        sb += `&appId=${appId}&DURL=${destinationpage}`;
        return sb;
    }

    function getRoutingDestination(destinationPage) {
        let durl = "";
        // Use provided session or fallback to browser sessionStorage
        const sessionStore = sessionStorage;
        /*       let destinationPage = sessionStore.getItem(WebConstant.DURL)
                   ? sessionStore.getItem(WebConstant.DURL)
                   : "https://www.collegeboard.org";*/

        const flow = sessionStore.getItem(WebConstant.FLOW);
        let reqVerify = false;

        if (sessionStore.getItem(WebConstant.IS_VERIFY) !== null) {
            // Parse boolean from session (stored as string in sessionStorage)
            reqVerify = sessionStore.getItem(WebConstant.IS_VERIFY) === "true";
        }

        // Step 4: Determine durl based on conditions
        if (useSedWidget() && !reqVerify && flow !== "newAccount") {
            durl = getDurlWithSedWidget(destinationPage);
        } else {
            durl = destinationPage;
        }

        // Step 5: Remove session attributes
        sessionStore.removeItem(WebConstant.FLOW);
        sessionStore.removeItem(WebConstant.IS_VERIFY);

        return durl;
    }

    // Render a loading state while the token exchange happens
    /* return (
      <div>
        <h2>Done with exchangeToken...</h2>
        {authResponse && (
          <div className="login">
            <p>Debug only: authResponse: {authResponse.unifiedSessionId}</p>
            <p>Debug only: destination: {destinationPage}</p>
          </div>
        )}
      </div>
    ); */

    return null;
};

export default ExchangeToken;
